"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MenuItemsForDropDown = function MenuItemsForDropDown(set, dropdownoptions) {
  var parsetoInt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var ret = dropdownoptions.filter(function (ddo) {
    return ddo.set === set;
  }).sort(function (a, b) {
    return a.seq - b.seq;
  });

  if (parsetoInt) {
    ret = ret.map(function (item) {
      var x = _objectSpread({}, item);

      x.value = parseInt(item.value);
      return x;
    });
  }

  return ret.map(function (item) {
    if (item.description.indexOf("/") > -1) {
      return item.description.split("/").reverse().map(function (subitem, si) {
        return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          key: item.value + "_" + si,
          value: item.value + "_" + si
        }, subitem.trim());
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        key: item.value,
        value: item.value
      }, item.description);
    }
  });
};

var _default = MenuItemsForDropDown;
exports.default = _default;